<template>
  <div class="loading-wrapper">
    <div class="spinner">Loading...</div>
  </div>
</template>

<style scoped>
.spinner {
  font-size: 20px;
  color: #888;
  animation: pulse 1s infinite;
}
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
}

@keyframes pulse {
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
}
</style>
<script setup>
</script>